var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-template',{attrs:{"header":_vm.header,"is-loading":_vm.isLoading}},[_c('div',{staticClass:"container-fluid container"},[_c('h1',[_vm._v("Villa Management")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.villaManagement)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }